var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-c",attrs:{"id":"innovation"}},[_c('van-image',{staticClass:"flex-self-ctr",attrs:{"src":_vm.innovation,"width":"10rem"}}),_c('van-image',{staticClass:"flex-self-ctr",attrs:{"src":_vm.logo,"width":"10rem"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }